import { useSuspenseQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import type { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Api } from "@/api.config";
import { LinkGen, QueryKeys } from "@/LinkGen";

interface ProtectedRoutesProps {
  auth: boolean;
}

export const AuthRoutes: FC<ProtectedRoutesProps> = (props) => {
  const { data } = useSuspenseQuery({
    queryKey: QueryKeys.Profile(),
    queryFn: () =>
      Api.Profile().catch((e) => {
        if (isAxiosError(e) && e.response?.status === 401) {
          // Handle log our/log in requirement
          return null;
        }
        throw e;
      }),
  });

  if (props.auth && data === null) {
    return <Navigate to={LinkGen.Auth()} />;
  }

  if (!props.auth && data !== null) {
    return <Navigate to={LinkGen.RFQ()} />;
  }

  return <Outlet />;
};
